// dependencies
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from '@vercel/analytics/react';

// contexts
import { AuthProvider } from "./contexts/AuthContext";
import { DBProvider } from "./contexts/DBContext";
import { StorageProvider } from "./contexts/StorageContext";

// misc
import ProtectedRoute from "./components/misc/ProtectedRoute";

// layout
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";

// === Pages === //
// home
import Dashboard from "./pages/home/Dashboard";

// profile
import Login from "./pages/auth/Login";
import Profile from "./pages/auth/Profile";

// contact
import Contact from "./pages/contact/Contact";

// projects
import Projects from "./pages/projects/Projects";
import Project from "./pages/projects/Project";
import AddProject from "./pages/projects/AddProject";

// other
import NotFound from "./components/misc/NotFound";

// style
import "./index.css";
import EditProject from "./pages/projects/EditProject";
import ScrollToTop from "./components/misc/ScrollToTop";



const App = () => {
    return (
        <AuthProvider>
        <DBProvider>
        <StorageProvider>
        <Router>
            <Routes>
                {/* wrapping with Navbar and Footer */}
                <Route path="*" element={
                    <>
                    <Navbar />
                    <div className="app-page-container">
                        <Routes>
                            {/* home */}
                            <Route path="/CodeNameHaar" element={<Dashboard />} />
                            <Route path="/" element={<Dashboard />} />

                            {/* progile */}
                            <Route path="/profile" element={
                                <ProtectedRoute>
                                    <Profile />
                                </ProtectedRoute>
                            } />

                            {/* contact */}
                            <Route path="/contact" element={<Contact />} />

                            {/* projects */}
                            <Route path="/projects" element={<Projects />} />
                            <Route path="/projects/:id" element={<Project />} />
                            <Route path="/projects/add" element={
                                <ProtectedRoute>
                                    <AddProject />
                                </ProtectedRoute>
                            } />
                            <Route path="/projects/edit/:id" element={
                                <ProtectedRoute>
                                    <EditProject />
                                </ProtectedRoute>
                            } />
                
                            {/* login */}
                            <Route path="/login" element={<Login />} />

                            {/* not found */}
                            <Route path="*" element={
                                <NotFound notFound={true} wrongPermissions={false} />
                            } />
                        </Routes>
                    </div>
                    <Footer />
                    </>
                } />
            </Routes>

            {/* scroll to top on route change */}
            <ScrollToTop />

        </Router>

        {/* analytics */}
        <Analytics />
        
        </StorageProvider>
        </DBProvider>
        </AuthProvider>
    );
};

export default App;
